<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed bg-gray-600/75 w-full h-full inset-0 z-40 overflow-x-hidden overflow-y-hidden flex justify-center"
    >
      <div class="fixed inset-0 transparent" @click="hide"></div>
      <div class="modal">
        <slot name="header">
          <header
            class="border-b border-gray-500 flex justify-between px-4 py-2 flex-grow-0 font-londrina"
          >
            <div class="text-lg">{{ title }}</div>
            <button type="button" @click="hide">x</button>
          </header>
        </slot>
        <div class="p-4 flex-1 overflow-y-auto">
          <slot>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Aspernatur nobis autem tempore hic. Exercitationem perspiciatis,
              et nostrum provident itaque tenetur porro, numquam mollitia eum
              non cum, blanditiis ad vel cupiditate?
            </p>
          </slot>
        </div>
        <slot name="footer">
          <footer
            class="border-t border-gray-500 flex justify-end items-center px-4 py-2 flex-grow-0"
          >
            <button
              v-if="!noClose"
              class="px-4 py-2 mx-2 bg-gray-400 rounded"
              type="button"
              @click="close"
            >
              {{ closeText }}
            </button>
            <button
              v-if="!noConfirm"
              class="px-4 py-2 mx-2 bg-blue-400 rounded text-gray-800"
              type="button"
              :disabled="disableConfirm"
              @click="confirm"
            >
              {{ confirmText }}
            </button>
          </footer>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Modal' },
    confirmText: { type: String, default: 'Confirm' },
    closeText: { type: String, default: 'Close' },
    noClose: { type: Boolean, default: false },
    noConfirm: { type: Boolean, default: false },
    disableConfirm: { type: Boolean, default: false },
  },
  data: () => {
    return {
      visible: false,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
      this.hide();
    },
    toggle() {
      this.visible = !this.visible;
    },
    hide() {
      this.$emit('hide');
      this.visible = false;
    },
    show() {
      this.visible = true;
    },
  },
};
</script>

<style lang="postcss">
.modal {
  @apply w-full bg-gray-800 text-indigo-50 mx-4 my-auto border-gray-700 rounded shadow-2xl flex flex-col z-50;
  min-height: 40%;
  max-height: 70%;
}
@screen md {
  .modal {
    @apply w-1/2 mx-auto;
  }
}
.fade-leave-active,
.fade-enter-active {
  @apply transition duration-500;
  .modal {
    @apply origin-top-left transform transition duration-500;
  }
}
.fade-leave-to,
.fade-enter {
  @apply opacity-0;
  .modal {
    @apply scale-0 -translate-x-1/2 -translate-y-1/2;
  }
}
.fade-enter-to {
  @apply opacity-100;
  .modal {
    @apply scale-100;
  }
}
</style>
